/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { GET_FINANCE, GET_FINANCE_SUMMARY } from '../queries/finance';
import { PaymentOutput, PaymentsQuery } from '../gql/graphql';

export const useGetFinanceSummary = () => {
  return useQuery<any[], Error>({
    queryKey: ['financeSummary'],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getTransactionSummary: any[] },
        { query: any }
      >(GET_FINANCE_SUMMARY);
      return data.getTransactionSummary.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
    },
  });
};

export const useGetFinance = (queries: PaymentsQuery) => {
  return useQuery<{ data: PaymentOutput[]; total: number }, Error>({
    queryKey: ['finance', queries],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getTransactions: any },
        { queries: PaymentsQuery }
      >(GET_FINANCE, { queries });
      return {
        data: data.getTransactions.data,
        total: data.getTransactions.total,
      };
    },
  });
};
